module.exports = __webpack_public_path__ + "static/yuja-wang-avatar.fbf11c71.png";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/reviews/yuja-wang-avatar.png
// module id = 1214
// module chunks = 0 1 2 3